// Tiny client for the tavern progress API.

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute("content") : "";
}

export async function updateProgress(payload) {
  const res = await fetch("/tavern/progress", {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": csrfToken(),
    },
    body: JSON.stringify(payload),
    credentials: "same-origin",
  });

  if (!res.ok) return null;
  return res.json();
}
